import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Project, ProjectPortfolio } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeProjectFromPortfolio(
    request: Boundaries["removeProjectFromPortfolio"]["request"],
  ): void;
}

function useRemoveProjectFromPortfolio(
  portfolio: Identifiable<ProjectPortfolio>,
  project: Identifiable<Project>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveProjectFromPortfolioRequestPending(portfolio, project),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveProjectFromPortfolioRequestSuccess(portfolio, project),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveProjectFromPortfolioRequestFailure(portfolio, project),
    ),
    removeProjectFromPortfolio: core.removeProjectFromPortfolio,
  };
}

export { useRemoveProjectFromPortfolio };
